/* eslint-disable react/prop-types */

import React from 'react';
import { Form, Col } from 'react-bootstrap';
import ErrorFeedback from './ErrorFeedback';
import { FormLabel } from './FormLabel';

const CheckBox = ({ metadata, register, field, errors }) => {
  return (
    <Col>
      <Form.Group as={Col} sm={12} lg={12} className="mb-3">
        <FormLabel
          label={metadata.label}
          required={metadata?.validation?.required}
        />
        <div>
          {metadata.options.map(option => (
            <Form.Check
              key={option.value}
              type="checkbox"
              label={option.label}
              name={field.name}
              onBlur={field.onBlur}
              ref={field.ref}
              value={option.value}
              checked={field.value?.includes(option.value)}
              onChange={e => {
                const valueArray = field.value || [];
                if (e.target.checked) {
                  field.onChange([...valueArray, option.value]);
                } else {
                  field.onChange(valueArray.filter(v => v !== option.value));
                }
              }}
            />
          ))}
        </div>
        <ErrorFeedback error={errors[metadata.id]} />
      </Form.Group>
    </Col>
  );
};

export default CheckBox;
